import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=45963314&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=45963314&prod&lang=scss&scoped=true"
import style1 from "./layout.vue?vue&type=style&index=1&id=45963314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45963314",
  null
  
)

export default component.exports